import { openDB } from 'idb'

export const DB_NAME = 'blaze-web-canvas'
// Version 1 shipped during the first local preview with an incomplete schema.
// Bumping the version makes IndexedDB run the upgrade callback for those
// browsers and adds any stores that are missing without deleting existing data.
export const DB_VERSION = 2

export const STORE_DEFINITIONS = Object.freeze([
  ['canvas_working_copies', { keyPath: 'id' }],
  ['canvas_view_state', { keyPath: 'canvasId' }],
  ['sync_outbox', { keyPath: 'canvasId' }],
  ['asset_uploads', { keyPath: 'hash' }],
  ['auth_ui_state', undefined],
])

export function ensureObjectStores(db) {
  for (const [name, options] of STORE_DEFINITIONS) {
    if (!db.objectStoreNames.contains(name)) db.createObjectStore(name, options)
  }
}

let databasePromise = null

export function getDatabase() {
  if (!databasePromise) {
    databasePromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        ensureObjectStores(db)
      },
    })
  }
  return databasePromise
}

export async function readStore(store, key) { return (await getDatabase()).get(store, key) }
export async function readAllStore(store) { return (await getDatabase()).getAll(store) }
export async function writeStore(store, value, key) {
  const db = await getDatabase()
  return key === undefined ? db.put(store, value) : db.put(store, value, key)
}
export async function deleteStore(store, key) { return (await getDatabase()).delete(store, key) }
